export const routes = {
  LandingPage: '/',
  DocumentPerCountryPage: '/policies/:type',
  DocumentPage: '/policies/:type/:country',
  MobileLegalAcceptancePage: '/mobile/legalAcceptance',
  MobileHeadlessDocumentPage: '/mobile/document/headless/:type',
  LicensesPage: '/ossattribution'
}
